module.exports = __webpack_public_path__ + "static/loading-a6c785eef004a69364f42289dc7e8566.gif";